module.exports = __webpack_public_path__ + "static/img/dingzhi01.e963fd7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/dingzhi01.jpg
// module id = /S69
// module chunks = 0